import * as React from 'react';

import { IconProps } from './Icon';

export const SyncStatusSuccessOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    viewBox="0 0 32 32"
    width={width}
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    y="0px"
  >
    <path d="m24.96 12.649a9 9 0 0 0 -17.917 0 7.5 7.5 0 0 0 1.457 14.851h15a7.5 7.5 0 0 0 1.46-14.851zm-1.46 12.851h-15a5.5 5.5 0 0 1 -.423-10.978 1.022 1.022 0 0 0 .923-1.022 7 7 0 0 1 14-.075v.1a1 1 0 0 0 .924 1 5.5 5.5 0 0 1 -.424 10.975z" />
    <path d="m19.793 15.293-5.293 5.293-2.293-2.293a1 1 0 0 0 -1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0 -1.414-1.414z" />
  </svg>
);
